// config/industryThemes.ts
export const industryThemes = {
  tech: {
    gradient: 'from-blue-600 via-purple-600 to-indigo-600',
    primary: '#6366F1',
    secondary: '#8B5CF6',
    accent: '#3B82F6',
    icon: '💻',
    badge: 'bg-blue-500',
    pattern: 'circuit',
    layout: 'grid',
  },
  music: {
    gradient: 'from-pink-500 via-purple-500 to-violet-600',
    primary: '#EC4899',
    secondary: '#A855F7',
    accent: '#8B5CF6',
    icon: '🎵',
    badge: 'bg-pink-500',
    pattern: 'wave',
    layout: 'timeline',
  },
  sports: {
    gradient: 'from-green-600 via-emerald-600 to-teal-600',
    primary: '#16A34A',
    secondary: '#059669',
    accent: '#14B8A6',
    icon: '⚽',
    badge: 'bg-green-600',
    pattern: 'diagonal',
    layout: 'cards',
  },
  healthcare: {
    gradient: 'from-teal-500 via-cyan-500 to-blue-500',
    primary: '#14B8A6',
    secondary: '#06B6D4',
    accent: '#0EA5E9',
    icon: '⚕️',
    badge: 'bg-teal-500',
    pattern: 'cross',
    layout: 'professional',
  },
  art: {
    gradient: 'from-purple-500 via-pink-500 to-rose-500',
    primary: '#A855F7',
    secondary: '#EC4899',
    accent: '#F43F5E',
    icon: '🎨',
    badge: 'bg-purple-500',
    pattern: 'artistic',
    layout: 'masonry',
  },
  business: {
    gradient: 'from-slate-700 via-gray-700 to-zinc-700',
    primary: '#475569',
    secondary: '#374151',
    accent: '#3F3F46',
    icon: '💼',
    badge: 'bg-slate-600',
    pattern: 'corporate',
    layout: 'columns',
  },
  food: {
    gradient: 'from-orange-500 via-red-500 to-pink-500',
    primary: '#F97316',
    secondary: '#EF4444',
    accent: '#EC4899',
    icon: '🍽️',
    badge: 'bg-orange-500',
    pattern: 'organic',
    layout: 'showcase',
  },
  education: {
    gradient: 'from-amber-500 via-orange-500 to-red-500',
    primary: '#F59E0B',
    secondary: '#F97316',
    accent: '#EF4444',
    icon: '📚',
    badge: 'bg-amber-500',
    pattern: 'books',
    layout: 'academic',
  },
  crypto: {
    gradient: 'from-orange-500 via-yellow-500 to-amber-500',
    primary: '#F97316',
    secondary: '#EAB308',
    accent: '#F59E0B',
    icon: '₿',
    badge: 'bg-orange-500',
    pattern: 'blockchain',
    layout: 'futuristic',
  },
  wedding: {
    gradient: 'from-rose-400 via-pink-400 to-fuchsia-400',
    primary: '#FB7185',
    secondary: '#F472B6',
    accent: '#E879F9',
    icon: '💒',
    badge: 'bg-rose-400',
    pattern: 'romantic',
    layout: 'elegant',
  },
} as const;

export type IndustryType = keyof typeof industryThemes;

export const getIndustryTheme = (industry: string) => {
  return industryThemes[industry as IndustryType] || industryThemes.tech;
};
